import { render, staticRenderFns } from "./custom-form-common-way.vue?vue&type=template&id=496213ee&scoped=true&"
import script from "./custom-form-common-way.vue?vue&type=script&lang=js&"
export * from "./custom-form-common-way.vue?vue&type=script&lang=js&"
import style0 from "./custom-form-common-way.vue?vue&type=style&index=0&id=496213ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496213ee",
  null
  
)

export default component.exports